import Path from "@core/FileProvider/Path/Path";

export const isShortEditorPath = (segments: string[]): boolean => {
	const offset = segments[0] === "public" ? 1 : 0;
	return (
		segments.slice(offset, offset + 3).length === 3 &&
		segments.slice(offset, offset + 3).every((segment) => segment !== "-") &&
		segments[offset + 3] === "-"
	);
};

export const expandShortEditorPath = (segments: string[]): string[] =>
	segments[0] === "public" ? ["public", "-", ...segments.slice(1)] : ["-", ...segments];

export const shortenEditorPath = (path: Path): Path => new Path(path.value.split("/").slice(1));
